export default __webpack_public_path__ + "static/media/1.6eef7fc2.png";